import builder from '../builder';
import OfficialBuilding3 from '../../streamline-icons/light/official-building-3.svg';

export default builder('IconOfficialBuilding3Light', OfficialBuilding3);
